import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  DOCUMENT_EXPERT_DETAILS_GET,
  DOCUMENT_EXPERT_DETAILS_RESET,
} from '../../redux/actions/documentsExpert';
import { Container } from '../../../ui/gridSystem';
import { CTA, HtmlRaw, Text } from '../../../ui/atoms';
import {
  CardContent,
  // Cover,
  DocumentCard,
  CardDownload,
  FileImg,
  CardFooter,
} from './style';
import { getIconByExtension } from '../../../utils/fileExtension';
import { downloadResource } from '../../../utils/fileDownload';
import routes from '../../../routes';
import theme from '../../../ui/theme';
import { formatFileSize } from '../../../utils/formatFileSize';
import { DocumentExpertComments } from '../../../ui/components';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import ModalDocDLConfirm, {
  ModalDocDLConfirmId,
} from '../../../ui/atoms/Modals/ModalDocDLConfirm';
import { MODAL_OPEN } from '../../redux/actions';
import { getUrlWithToken } from '../../../utils/common';

const DocumentExpertDetails = ({
  data,
  getDocumentExpertDetails,
  resetDocument,
  mediaIsPhone,
  modalOpen,
  isSubjectExpert,
}) => {
  const { document_id } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDocumentExpertDetails(document_id);

    return () => resetDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document_id]);

  useEffect(() => {
    if (data?.file) setFile(data.file);
  }, [data]);

  return (
    <>
      <Breadcrumb
        crumbs={[
          {
            label: 'Scambio documentale',
            onClick: () => navigate(routes.documentsExpert.path),
          },
          { label: `Dettaglio documento: ${data?.title}` },
        ]}
      />
      <Container className="pt-0 mb-5">
        <Text type="h1" mb={24}>
          {data?.title}
        </Text>
        {/* <Cover src={data?.cover} /> */}
        {data?.created && (
          <Text type="b4" mb={8} color={theme().colors.primaryDarkGray700}>
            {dayjs(data.created * 1000).format('DD/MM/YYYY')}
          </Text>
        )}
        <Text type="b3" mb={32}>
          <HtmlRaw html={data?.description} style={{ textAlign: 'justify' }} />
        </Text>
        <Text type="h1.5" mb={mediaIsPhone ? 24 : 32}>
          Documento scaricabile
        </Text>
        <DocumentCard>
          <FileImg src={getIconByExtension(file?.extension)} />
          <CardContent>
            {data?.categories?.length > 0 && (
              <Text type="statistics-heading">
                {(data?.categories || [])
                  .map((category) => category.name)
                  .join(', ')}
              </Text>
            )}
            <a
              href={getUrlWithToken(file?.url) || ''}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text type="h3" className="line-clamp link">
                {file?.filename}
              </Text>
            </a>
            <CardFooter>
              {data?.created && (
                <Text type="b4" color={theme().colors.primaryDarkGray700}>
                  {dayjs(data.created * 1000).format('DD/MM/YYYY')}
                </Text>
              )}
              <CardDownload>
                <Text type="b5" color={theme().colors.primaryDarkGray700}>
                  {formatFileSize(file?.size)}
                </Text>
                <CTA
                  onClick={() => {
                    isSubjectExpert
                      ? modalOpen(ModalDocDLConfirmId)
                      : downloadResource(
                          getUrlWithToken(file?.url),
                          file?.filename
                        );
                  }}
                  type="tertiary"
                  btnText="Download"
                  icon="download-01"
                />
              </CardDownload>
            </CardFooter>
          </CardContent>
        </DocumentCard>
        <DocumentExpertComments />
      </Container>
      {isSubjectExpert && (
        <ModalDocDLConfirm
          onClick={() =>
            downloadResource(getUrlWithToken(file?.url), file?.filename)
          }
        />
      )}
    </>
  );
};

DocumentExpertDetails.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC (connect, state)
  data: PropTypes.object,
  isSubjectExpert: PropTypes.bool,
  // HOC (connect, dispatch)
  getDocumentExpertDetails: PropTypes.func,
  resetDocument: PropTypes.func,
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    const { details: data } = state.documentsExpert;
    const { isSubjectExpert } = state.user;
    return {
      data,
      isSubjectExpert,
    };
  },
  (dispatch) => ({
    getDocumentExpertDetails: (id) =>
      dispatch({ type: DOCUMENT_EXPERT_DETAILS_GET._REQUEST, id }),
    resetDocument: () => dispatch({ type: DOCUMENT_EXPERT_DETAILS_RESET }),
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
  })
)(withMediaQueries(DocumentExpertDetails));
